<template>
  <div>
    <div class="zonghe">
      <!-- 面包屑 -->
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>积分报表</el-breadcrumb-item>
          <el-breadcrumb-item v-if="isMore">{{ moreTit }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl">
          <el-button
            v-if="isMore"
            type="text"
            icon="el-icon-arrow-left"
            class="but-black"
            @click="hidenMore"
          >
            返 回
          </el-button>
          学年：
          <el-date-picker
            :clearable="false"
            class="search-year"
            v-model="searchYear"
            value-format="yyyy"
            size="small"
            type="year"
            @change="search"
          >
          </el-date-picker>
          学期：
          <el-select v-model="searchTerm" size="small" @change="search">
            <template v-for="i of dic.schoolTerm">
              <el-option
                :key="i.id"
                :label="i.dicName"
                :value="i.dicCode"
              ></el-option>
            </template>
          </el-select>
          <span v-if="isMore">
            搜索：<el-input
              type="text"
              style="width: 200px"
              v-model="searchKey"
              @change="search(1)"
              size="small"
              placeholder="请输入教师姓名"
              clearable
            ></el-input>
          </span>
        </div>
      </div>

      <el-row :gutter="13" style="margin-bottom: 13px">
        <el-col :span="7" :offset="0">
          <div class="card teacher-info-card">
            <div class="card-body-t">
              <div class="tl">
                <el-avatar
                  :size="90"
                  v-if="userInfo.userLogo"
                  :src="userInfo.userLogo"
                ></el-avatar>
                <img
                  style="
                    border-radius: 50%;
                    width: 90px;
                    display: block;
                    margin: 0 14px;
                  "
                  v-else
                  src="../../../assets/image/other/headMan.png"
                />
                <div class="tn">{{ userInfo.userName }}</div>
                <div
                  style="
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                  "
                >
                  <div class="td" v-for="n in disciplineNames">
                    {{ n }}
                  </div>
                </div>
              </div>
              <div class="tr">
                <table style="width: 100%; table-layout: fixed">
                  <tr>
                    <td class="tt">师训号：</td>
                    <td class="tc">{{ teacherInfo.teacherNum }}</td>
                  </tr>
                  <tr>
                    <td class="tt">教龄：</td>
                    <td class="tc">
                      {{ teacherInfo.teachingAge }}
                      <span v-if="teacherInfo.teachingAge">年</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="tt">学历：</td>
                    <td class="tc">{{ teacherInfo.educationDesc }}</td>
                  </tr>
                  <tr>
                    <td class="tt">毕业院校：</td>
                    <td class="tc">{{ teacherInfo.graduateSchool }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="7" :offset="0">
          <div class="card">
            <div class="card-title">积分分布</div>
            <div class="card-body">
              <echart :option="pieOption"></echart>
            </div>
          </div>
        </el-col>
        <el-col :span="10" :offset="0">
          <div class="card">
            <div class="card-title">积分趋势</div>
            <div class="card-body">
              <echart :option="lineOption"></echart>
            </div>
          </div>
        </el-col>
      </el-row>
      <intergral-sta
        style="margin-bottom: 13px"
        ref="intergralStaRef"
        :searchYear="searchYear"
        :searchTerm="searchTerm"
      ></intergral-sta>

      <div class="card" style="height: auto">
        <div class="card-title">积分明细</div>
        <el-form :inline="true" :model="form" style="margin-top: 12px">
          <el-form-item label="搜索">
            <el-input
              placeholder="请输入关键词搜索"
              prefix-icon="el-icon-search"
              v-model="form.keyword"
              @change="refresh"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="积分来源">
            <el-select v-model="form.module" @change="refresh" size="small">
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="n in options"
                :label="n.modelName"
                :value="n.modelCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="获奖日期">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd"
              v-model="form.date"
              type="daterange"
              align="right"
              unlink-panels
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="refresh"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button
              style="background: #36cb8c; color: white"
              size="small"
              :disabled="tableData.length == 0"
              @click="exportFile"
              >导出</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          v-loading="isTableLoading"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="index"
            label="序号"
            type="index"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="title" label="项目名称"> </el-table-column>
          <el-table-column
            prop="modelName"
            label="积分来源"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="获取时间"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="score"
            label="积分数量"
            align="center"
            width="120"
          >
          </el-table-column>
        </el-table>

        <div class="page">
          <pagination
            :pageObj="pageObj"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          >
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import Pagination from "@/components/Pagination.vue";
import echart from "@/components/echarts";
import IntergralSta from "@/components/echarts/IntergralSta";

import { mapState } from "vuex";
export default {
  components: {
    Pagination,
    echart,
    IntergralSta,
  },
  computed: {
    ...mapState(["isAdmin", "userInfo", "dic"]),
    pieOption() {
      let option = {
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          type: "category",
          data: this.pieData?.xAxisList,
        },
        yAxis: {
          type: "value",
        },

        series: [
          {
            type: "bar",
            data: this.pieData?.dataList?.map((u) => ({
              value: u.value,
              itemStyle: {
                color:
                  u.level == 1
                    ? "#37cb8c"
                    : u.level == 2
                    ? "#e99d42"
                    : "#d70e19",
              },
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
    lineOption() {
      let option = {
        legend: {},
        dataset: {
          source: this.lineData,
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            seriesLayoutBy: "row",
            type: "line",
          },
          {
            seriesLayoutBy: "row",
            type: "line",
          },
        ],
      };
      return option;
    },
    teacherInfo() {
      if (this.userInfo) {
        return this.userInfo.teacherArchivesDTO;
      } else {
        return {
          teacherArchivesDTO: "",
          teachingAge: "",
          education: "",
          graduateSchool: "",
        };
      }
    },
    disciplineNames() {
      let list = this.userInfo.teacherInfoList.map((m) => m.disciplineName);
      list = Array.from(new Set(list));
      return list;
    },
  },
  data() {
    return {
      form: {
        keyword: "",
        module: "",
        date: null,
      },
      options: [],
      isMore: false,
      moreTit: "",
      moreUrl: "",
      isTableLoading: false,
      tableData: [],
      maxPageScore: "",
      // 加载
      httpFinish: false,
      loading: false,
      pieData: [],
      lineData: [],
      searchYear: "",
      searchTerm: "",
      searchKey: "",
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
    };
  },
  created() {
    this.searchYear = this.curYearPro;
    this.searchTerm = this.curTermPro;
    this.getScoreResourceList();
    this.query();
    this.getTeacherScoreDetailList();
  },

  methods: {
    exportFile() {
      this.$axios
        .post(
          "/teacherScore/exportTeacherScoreInfoDetail",
          this.$qs.stringify({
            keyword: this.form.keyword,
            modelCode: this.form.module,
            pageNum: this.pageObj.current,
            pageSize: this.pageObj.size,
            schoolCode: this.userInfo.schoolCode,
            schoolTerm: this.searchTerm,
            schoolYear: this.searchYear,
            teacherId: this.userInfo.userId,
            queryEndDate: this.form.date == null ? null : this.form.date[1],
            queryStartDate: this.form.date == null ? null : this.form.date[0],
          }),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let fileName = window.decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          const url = URL.createObjectURL(res.data);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.click();
          URL.revokeObjectURL(url);
          // saveAs(res, `${this.userInfo.userName}-积分报表.xls`);
        });
    },
    refresh() {
      this.pageObj.curPage = 1;
      this.getTeacherScoreDetailList();
    },
    search() {
      this.pageObj.curPage = 1;
      this.getTeacherScoreDetailList();
      this.query();
      this.$refs.intergralStaRef.rankLsit();
    },
    getTeacherScoreDetailList() {
      this.isTableLoading = true;
      this.$axios
        .post("/teacherScore/getTeacherScoreDetailPage", {
          keyword: this.form.keyword,
          modelCode: this.form.module,
          pageNum: this.pageObj.current,
          pageSize: this.pageObj.size,
          schoolCode: this.userInfo.schoolCode,
          schoolTerm: this.searchTerm,
          schoolYear: this.searchYear,
          teacherId: this.userInfo.userId,
          queryEndDate: this.form.date == null ? null : this.form.date[1],
          queryStartDate: this.form.date == null ? null : this.form.date[0],
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.pageObj.current = res.data.current;
          this.pageObj.size = res.data.size;
          this.pageObj.total = res.data.total;
        })
        .finally(() => {
          this.isTableLoading = false;
        });
    },
    query() {
      let params = {
        regionId: this.userInfo.teacherSchoolList[0].provinceId,
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm,
        schoolYear: this.searchYear,
        teacherId: this.userInfo.userId,
      };
      this.$axios
        .post(
          "/teacherScore/getTeacherModelScoreBar",
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res && res.data) {
            this.pieData = res.data;
          } else {
            this.pieData = [];
          }
        });

      this.$axios
        .post("/teacherScore/getTeacherScoreTrendLine", params)
        .then((res) => {
          if (res && res.data) {
            this.lineData = res.data;
          } else {
            this.lineData = [];
          }
        });
      //
    },
    getScoreResourceList() {
      this.$axios
        .post(
          "/rpt/getScoreMenuInfoList",
          this.$qs.stringify({
            schoolCode: this.userInfo.schoolCode,
          })
        )
        .then((res) => {
          this.options = res.data;
        });
    },

    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.getTeacherScoreDetailList();
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage;
      this.getTeacherScoreDetailList();
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  padding: 8px 14px;
  border-radius: 8px;
  background-color: white;
  height: 270px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .card-title {
    border-bottom: 1px solid rgba(151, 151, 151, 0.15);
    font-size: 16px;
    font-weight: 500;
    color: #3b414d;
    padding-bottom: 8px;
  }

  .card-body {
    flex: 1;
  }
}

.teacher-info-card {
  padding: 15px 19px;
  background: url(../../../../public/card.png) no-repeat center/cover;

  .card-body-t {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(3px);
    border-radius: 8px;
    display: flex;
    align-items: center;
  }

  .tl {
    text-align: center;
    padding: 6px 14px;
    border-right: 1px solid #d4d4d4;
  }

  .tr {
    line-height: 2;
    padding: 10px;

    .tt {
      width: 70px;
      text-align: right;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      white-space: nowrap;
    }
    .tc {
      font-size: 14px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .tn {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 2.2;
  }

  .td {
    white-space: nowrap;
    width: auto;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    padding: 1px 9px;
    background: rgba(229, 238, 235, 0.3);
    border-radius: 2px;
    border: 1px solid #518d7b;
    margin-right: 2px;
    margin-bottom: 2px;
  }
}

.zonghe {
  padding: 18px;
  overflow: hidden;

  .crumbs {
    height: 30px;

    .el-breadcrumb {
      font-size: 15px;
    }
  }

  .top {
    background: #fff;
    line-height: 60px;
    height: 60px;
    padding: 0px 20px;
    font-size: 15px;
    margin-bottom: 13px;
    border-radius: 8px;

    .el-select {
      margin-right: 20px;
    }

    /deep/.el-input {
      width: none !important;

      .el-input__inner {
        width: none !important;
      }
    }

    .el-button.but-black {
      background: #fff;
      color: #409eff;
      margin-right: 10px;
    }

    .el-button {
      background: @theme-color;
      color: #fff;
      font-size: 14px;

      /deep/.iconfont {
        font-size: 15px;
        margin-right: 5px;
      }
    }
  }

  .page {
    background-color: #fff;
    padding-bottom: 8px;
    padding-right: 10px;
  }
}

.loding {
  height: 100vh;
}
</style>
